/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
        
import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'


export default function Menhir(props) {
  const group = useRef()
  const { nodes, materials } = useGLTF('/models/menhir.gltf')
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh geometry={nodes.menhir_moyen.geometry} material={materials['color_main.001']} />
    </group>
  )
}

useGLTF.preload('/models/menhir.gltf')